import { useEffect, useState } from 'react';
import ButtonIconGhostMedium from './ButtonIconGhostMedium';

const ButtonIconMediumChangeIconColor = ({
  id,
  icon: IconComponent,
  active,
  ...props
}) => {
  const colorDefault = {
    color1: '#818589',
    color2: '#E5E7E8',
    color3: '#AAB2B6',
  };
  const colorActive = {
    color1: '#494949',
    color2: '#FFE693',
    color3: '#FFC914',
  };
  const defaultIcon = <IconComponent />;

  const [icon, setIcon] = useState(defaultIcon);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    if (active) {
      setIcon(
        <IconComponent
          color1={colorActive.color1}
          color2={colorActive.color2}
          color3={colorActive.color3}
        />
      );
    } else setIcon(defaultIcon);
  }, [active]);

  return (
    <ButtonIconGhostMedium
      id={id}
      icon={<span className="w-24 h-24 flex">{icon}</span>}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      //   className={active ? "active" : ""}
      type="button"
      {...props}
      style={{ background: active ? '#2653A0' : '', ...(props?.style ?? {}) }}
    />
  );
};

export default ButtonIconMediumChangeIconColor;
